export default __webpack_public_path__ + "static/media/lg-a.0534eba6.jpg";